import {brandApiUrl} from '../_metronic/helpers/brand'

export const CORRELATION_HEADER = 'X-Correlation-ID'
export const CORRELATION_EVENT = 'megapay:correlation'

export const createCorrelationId = (): string => {
  const randomUuid = (window.crypto as any)?.randomUUID
  if (typeof randomUuid === 'function') return randomUuid.call(window.crypto).replace(/-/g, '')

  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('')
}

export const notifyCorrelationId = (correlationId?: string | null) => {
  if (!correlationId) return
  window.dispatchEvent(new CustomEvent(CORRELATION_EVENT, {detail: {correlationId}}))
}

export const reportClientError = (error: Error, source: string, correlationId: string) => {
  void window
    .fetch(`${brandApiUrl}/observability/client-error`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        [CORRELATION_HEADER]: correlationId,
      },
      body: JSON.stringify({
        name: error.name,
        message: error.message,
        stack: error.stack,
        source,
        location: window.location.href,
        userAgent: window.navigator.userAgent,
      }),
    })
    .catch(() => undefined)
}
